import { get, isUndefined } from 'lodash'

import types from './types'

export { default as actions } from './actions'

export const INITIAL_STATE = {}

const reducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case types.UPDATE_SAVED_SEARCH:
      return action.payload
    case types.CLEAR_SAVED_SEARCH:
      return action.payload
    default:
      return state
  }
}

export default reducer

export const selectSavedSearch = (store) => {
  const persistedSearch = get(store, 'savedSearch.query')
  if (!isUndefined(persistedSearch)) {
    return persistedSearch
  }
  return get(store, 'user.record.SavedSearch.FacetValues')
}

export const selectSavedNameSearch = (store) => {
  const persistedNameSearch = get(store, 'savedSearch.nameSearch')
  if (!isUndefined(persistedNameSearch)) {
    return persistedNameSearch
  }
  return get(store, 'user.record.SavedSearch.Name')
}
